import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby'

import Header from './header'
import './layout.css'

const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
            description
            author
            keywords
            siteUrl
          }
        }
      }
    `}
    render={data => (
      <>
        <Helmet
          title={data.site.siteMetadata.title}
          meta={[
            {
              name: 'description',
              content: data.site.siteMetadata.description,
            },
            {
              name: 'keywords',
              content: data.site.siteMetadata.keywords.join(','),
            },
            {
              name: 'author',
              content: data.site.siteMetadata.author,
            },
            {
              name: 'og:title',
              content: data.site.siteMetadata.title,
            },
            {
              name: 'og:type',
              content: 'profile',
            },
            {
              name: 'og:profile:first_name',
              content: 'Kartik',
            },
            {
              name: 'og:profile:last_name',
              content: 'Malik',
            },
            {
              name: 'og:profile:username',
              content: 'kartik2406',
            },
            {
              name: 'og:image',
              content: ''
            },
            {
              name: 'og:profile:gender',
              content: 'male',
            },
            {
              name: 'og:url',
              content: data.site.siteMetadata.siteUrl,
            }
          ]}
        >
          <html lang="en" />
        </Helmet>
        <Header siteTitle={data.site.siteMetadata.title} />
        <div
          className="container"
          style={{
            paddingTop: 0,
          }}
        >
          {children}
        </div>
      </>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
